<template>

  <div>

    <b-container>

      <div class="mt-4 mb-4 d-flex align-items-center justify-content-between">
        <div class="burger-spacing">
          <h1 class="page-title">{{$t('Commissions')}}</h1>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add')}} {{$t('a.e')}} {{$t('commission')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b122-table
          ref="B122TableCommission"
          identifier="B122TableCommission"
          init-b122-table-url="/commission/initB122Table"
          get-b122-table-results-url="/commission/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('commission.emptyTitle').toString()"
          :empty-text="$t('commission.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">

          <template v-slot:top-row>
            <td class="bold-text">{{$t('Total')}}</td>
            <td class="bold-text"></td>
            <td class="bold-text">{{ totalInfos.nbMembers }}</td>
            <td class="bold-text">{{ totalInfos.nbNewProjects }}</td>
            <td class="bold-text">{{ totalInfos.nbInfosNeededProjects }}</td>
            <td class="bold-text">{{ totalInfos.nbRefusedProjects }}</td>
            <td class="bold-text">{{ totalInfos.nbCertifiedProjects }}</td>
            <td class="bold-text">{{ totalInfos.nbTotalProjects }}</td>
            <td></td>
          </template>

        </b122-table>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      itemSingularName="commission"
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="ui.selectedCommission"
      :selectedItemSpecialString="ui.selectedCommission ? ui.selectedCommission.tostring : null"
      controllerName="commission"
      itemSingularNameUpp="Commission"
      @didDeleteItem="didDeleteCommission()">
    </Item-delete-modal>

  </div>

</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue"
import api from "../../services/api";

export default {

  name: 'CommissionIndex',

  components: {
    ItemDeleteModal,
    B122Table,
  },

  data() {
    return {
      totalCount: 0,
      allowCreate: this.$store.getters.isAdmin,
      allowDelete: this.$store.getters.isAdmin,
      allowEdit: this.$store.getters.isAdmin,
      totalInfos: {
        nbMembers: null,
        nbNewProjects: null,
        nbInfosNeededProjects: null,
        nbRefusedProjects: null,
        nbCertifiedProjects: null,
        nbTotalProjects: null
      },
      ui: {
        selectedCommission: null
      }
    }
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('commission.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$i18n.t('commission.DisplayOrder'),
          key: 'displayOrder',
          sortable: true
        },
        {
          label: this.$i18n.t('commission.Members'),
          key: 'nbUsers',
          sortable: false
        },
        {
          label: this.$i18n.t('projects.New'),
          key: 'nbSubmitedProject',
          sortable: false,
          class: 'border-left'
        },
        {
          label: this.$i18n.t("projects.UncertifiedInfosNeeded"),
          key: 'nbInfoNeededProject',
          sortable: false
        },
        {
          label: this.$i18n.t('projects.Refused'),
          key: 'nbRefusedProject',
          sortable: false
        },
        {
          label: this.$i18n.t('projects.Certified'),
          key: 'nbCertifiedProjects',
          sortable: false
        },
        {
          label: this.$i18n.t('projects.Total'),
          key: 'nbTotalProjects',
          class: 'border-left bold-text',
          sortable: false
        },
        {
          label: '',
          key: 'actions',
          sortable: false
        }
      ]
    }

  },

  mounted() {
    this.fetchData();
  },

  methods: {

    fetchData() {
      this.fetchTotalInfos()
    },

    fetchTotalInfos () {
      api
        .get(`/commission/getTotals`)
        .then(response => {
          this.totalInfos.nbMembers = response.data.membersNumber
          this.totalInfos.nbNewProjects = response.data.newProjectsNb
          this.totalInfos.nbInfosNeededProjects = response.data.infosNeededProjectsNb
          this.totalInfos.nbRefusedProjects = response.data.refusedProjectsNb
          this.totalInfos.nbCertifiedProjects = response.data.certifiedProjectsNb
          this.totalInfos.nbTotalProjects = response.data.totalProjectsNb
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'CommissionCreate'
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'CommissionEdit',
        params: {
          commissionId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedCommission = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteCommission() {
      this.ui.selectedCommission = null
      this.$refs.B122TableCommission.refreshTable()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/commission/CommissionIndex.vue